import React from 'react';
import styles from './TipBoxTop.module.scss';

/* Providers */
import { UnavailableTag } from '../../UnavailableTag/UnavailableTag';

interface TipBoxTopProps {}

export const UnavailableTipBoxTop: React.FC<TipBoxTopProps> = () => {
  return (
    <div className={styles.innerTopBox}>
      <UnavailableTag />
    </div>
  );
};
